// extracted by mini-css-extract-plugin
module.exports = {"postsBlock":"MyPosts_postsBlock__2ifKf","posts":"MyPosts_posts__3tZ1c"};